import React from 'react';
import { getOrgTierInfo } from 'js/lib/AccountUtils';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import useOrganizationTrialStatus from 'new/components/OrganizationTrialStatus/useOrganizationTrialStatus';

import styles from './OrganizationTrialStatus.module.scss';

type Props = {
  type?: 'inline' | 'usage';
};

export default function OrganizationTrialStatus({ type = 'inline' }: Props) {
  const organization = useCurrentOrg();
  const { label, isExpired, isUnlimited, quotaLimitExceeded } = useOrganizationTrialStatus();

  if (isUnlimited) {
    return null;
  }

  const classNameContainer =
    isExpired || quotaLimitExceeded ? styles.trialContainerExpired : styles.trialContainerActive;

  const classNameText =
    isExpired || quotaLimitExceeded ? styles.trialLabelExpired : styles.trialLabelActive;

  const trial_status = label ? (
    <div className={classNameContainer}>
      <span className={classNameText}>{label}</span>
    </div>
  ) : null;

  if (type === 'inline') {
    return trial_status;
  }

  const info = getOrgTierInfo(organization);
  const usageSourcesValue = info?.counts?.usage?.value ?? null;
  const usageSourcesDescription = info?.counts?.usage?.subText ?? null;
  const activeSourcesValue = info?.counts?.active_sources?.value ?? null;

  if (type === 'usage' && info?.counts) {
    return (
      <div className={styles.containerUsage} aria-label="organization-trial-status">
        <div className="grid-center">{trial_status}</div>

        <ul className={styles.usageListInformation}>
          <li>
            <span className={styles.label}>Usage limits</span>
            <span className={styles.value}>
              {usageSourcesValue} {usageSourcesDescription}
            </span>
          </li>

          <li>
            <span className={styles.label}>Active sources</span>
            <span className={styles.value}>{activeSourcesValue}</span>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div
      style={{ marginBottom: 'var(--spacing-md)' }}
      className="grid-center"
      aria-label="organization-trial-status"
    >
      {trial_status}
    </div>
  );
}
